import Close from '@mui/icons-material/Close';
import { Box, IconButton, SxProps, Typography } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router';

import { CaptureHeaderWrapper } from './CaptureHeaderWrapper';

interface CaptureHeaderProps {
  onClose?: () => any;
  actions?: React.ReactNode;
  title?: string;
  sx?: SxProps;
  hideActions?: boolean;
}

export const CaptureHeader = ({ actions, title = '', onClose, sx, hideActions }: CaptureHeaderProps) => {
  const navigate = useNavigate();
  const handleNavigateBack = () => navigate(-1);
  return (
    <CaptureHeaderWrapper
      sx={{
        display: 'grid',
        gridTemplateColumns: '1fr 1fr 1fr',
        alignItems: 'center',
        pr: 3,
        pl: 1,
        boxShadow:
          '0px 1px 10px rgba(0, 0, 0, 0.12), 0px 4px 5px rgba(0, 0, 0, 0.14), 0px 2px 4px -1px rgba(0, 0, 0, 0.2)',
        ...sx,
      }}
    >
      <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
        <IconButton onClick={onClose || handleNavigateBack}>
          <Close style={{ fontSize: '30px', color: 'white' }} />
        </IconButton>
      </Box>
      {title && (
        <Typography sx={{ textAlign: 'center' }} fontWeight="bold" color="white">
          {title}
        </Typography>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>{actions && !hideActions && actions}</Box>
    </CaptureHeaderWrapper>
  );
};
